/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import Notes from './Notes/index'
import React from 'react'
import Receivables from './Receivables/index'
import Transactions from './Transactions/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabSelectedLedgerViewModeValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.view_mode',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabSelectedLedgerViewModeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Receivables'}>
<Receivables
  viewPath={`${viewPath}/Receivables`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Transactions'}>
<Transactions
  viewPath={`${viewPath}/Transactions`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Notes'}>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}